<template>
  <div v-loading="loading" style="height: 698px;overflow: scroll;">
    <el-page-header
      @back="goBack"
      class="page_header"
      :content="title"
    ></el-page-header>
    <span>账号：{{ username }}</span>
    <div class="table_list">
      <div>
        <!-- <span>检验平台</span> -->
        <div style="text-align: left;padding-left: 20px;  margin-bottom: 8px;border-left:5px solid #983cc9">检验平台</div>
        <el-table
          border
          :data="[data.testing_platform_dict]"
          style="width: 100%"
        >
          <el-table-column prop="platform_2" align="center" label="罗"></el-table-column>
          <el-table-column prop="platform_4" align="center" label="雅"></el-table-column>
          <el-table-column prop="platform_5" align="center" label="贝"></el-table-column>
          <el-table-column prop="platform_6" align="center" label="西"></el-table-column>
          <el-table-column prop="platform_3" align="center" label="迈"></el-table-column>
          <el-table-column prop="platform_1" align="center" label="其他"></el-table-column>
        </el-table>
      </div>
      <div style="margin-left: 10px;">
        <!-- <div style="text-align: center;  margin-bottom: 8px;"></div> -->
        <div style="text-align: left;padding-left: 20px;  margin-bottom: 8px;border-left:5px solid #983cc9">异常指标数量</div>
        <el-table
          v-if="Object.keys(tableData[0]).length > 0"
          border
          :data="tableData"
          style="width: 100%; max-width: 100%; overflow-x: auto"
        >
          <el-table-column
            v-for="(item, index) in abnormal_data"
            :prop="item.name"
            :label="item.name"
            :key="index"
            align="center"
          >
            <template slot-scope="scope">
              <span class="link" @click="show_effect_factor_data(item.name)">{{
                scope.row[item.name]
              }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-else class="prompt">
          <span>无异常指标数据</span>
        </div>
      </div>
    </div>

    <template v-if="effect_factor_data.length > 0">
      <div class="title">{{ effect_factor.name }}</div>
      <el-table border :data="effect_factor.data"  style="width: 100%">
        <el-table-column
          v-for="(item, index) in effect_factor_data"
          :prop="item.name"
          :label="item.name+'次数'"
          :key="index"
          align="center"
        >
          <template slot-scope="scope">
            <span class="link" @click="show_disease_data(item.name)">{{
              item.number
            }}</span>
          </template>
        </el-table-column>

      </el-table>
    </template>

    <template v-if="disease.data.length > 0">
      <div class="title">{{ disease.name +'次数' }}</div>
      <el-table border :data="disease.data" style="width: 100%">
         <el-table-column
          v-for="(item, index) in disease_data"
          :prop="item.name"
          :label="item.name+'次数'"
          :key="index"
          align="center"
        >
        <template slot-scope="scope">
            <span class="link" @click="show_disease_info_data(item.name)">{{
              item.number
            }}</span>
          </template>
        </el-table-column>

      </el-table>
    </template>

    <template v-if="disease_info.data.length > 0">
      <div class="title">{{ disease_info.name +'次数' }}</div>
      <el-table border :data="disease_info.data" style="width: 100%">
        <el-table-column
          v-for="(item, index) in disease_info_data"
          :prop="item.name"
          :label="item.name"
          :key="index"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ item.number }}</span>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>

<script>
import {
  get_anomaly_index_data,
  get_effect_factor_data,
  get_disease_data,
  get_disease_info_data
} from "@/api/DataSearch";

export default {
  name: "anomaly_index",
  props: {
    user_id: {
      type: Number,
    },
    title: {
      type: String,
    },
    username: {
      type: String,
    },
    name: {
      type: String,
    },
    report_type: {
      type: Number,
    },
  },
  data() {
    return {
      factor_type:'',
      indicator:'',
      effect_factor: {
        name: "",
        data: [],
      },
      disease: {
        name: "疾病因素次数",
        data: [],
      },
      disease_info: {
        name: "",
        data: [],
      },
      data: {},
      loading: false,
    };
  },
  created() {
    this.loading = true;
    const params = {
      user_id: this.user_id,
      report_type: this.report_type,
    };
    get_anomaly_index_data(params).then((res) => {
      // console.log(res, "res");

      this.loading = false;
      const { data } = res;
      if (data["code"] === 200) {
        this.data = {
          anomalies_indicateurs_dict: data.data["abnormal_indicators"],
          testing_platform_dict: data.data["platform_stats"],
        };
      }
    });
  },
  methods: {
    goBack() {
      this.$router.push("/bec/static");
    },
    show_effect_factor_data(name) {
      this.loading = true;
      // console.log("name", name);
      this.indicator = name;
      get_effect_factor_data({
        user_id: this.user_id,
        report_type: this.report_type,
        indicator: name,
      }).then((res) => {
        // console.log(res, "effect_factor_data");
        if (res.data.code === 200) {
          this.effect_factor.name = res.data.data["indicator"];
          this.effect_factor.data = res.data.data["factor_stats"];
          this.disease.name = '';
          this.disease.data = [];
          this.disease_info.name = '';
          this.disease_info.data = [];
          this.loading = false;
        }
      });
    },
    show_disease_data(name) {
      this.loading = true;
      // console.log("name", name);
      this.factor_type = name;
      get_disease_data({
        user_id: this.user_id,
        report_type: this.report_type,
        indicator: this.indicator,
        factor_type: name,
      }).then((res) => {
        if (res.data.code === 200) {
          // console.log(res.data, "disease_data");
          this.disease.name = res.data.data["factor_type"];
          this.disease.data = res.data.data["disease_subtype_stats"];
          this.disease_info.name = '';
          this.disease_info.data = [];
          this.loading = false;
        }
      });
    },
    show_disease_info_data(name) {
      this.loading = true;
      get_disease_info_data({
        user_id: this.user_id,
        report_type: this.report_type,
        factor_type:this.factor_type,
        indicator: this.indicator,
        disease_category: name,
      }).then((res) => {
        if (res.data.code === 200) {
          // console.log(res.data, "disease_info_data");
          this.disease_info.name = res.data.data["disease_category"];
          this.disease_info.data = res.data.data["disease_items"];
          this.loading = false;
        }
      });
    },
  },
  computed: {
    disease_info_data(){
      const disease_info = []
      for (const key in this.disease_info.data[0]) {
        disease_info.push({
          name: key,
          number: this.disease_info.data[0][key],
        });
        }
      return disease_info;
    },
    disease_data(){
      const disease = []
      for (const key in this.disease.data[0]) {
        disease.push({
          name: key,
          number: this.disease.data[0][key],
        });
        }
      return disease;
    },
    effect_factor_data(){
      const effect_factor = []
      for (const key in this.effect_factor.data[0]) {
        effect_factor.push({
          name: key,
          number: this.effect_factor.data[0][key],
        });
        }
      return effect_factor;
    },
    tableData() {
      let data = {};
      for (let i = 0; i < this.abnormal_data.length; i++) {
        data[this.abnormal_data[i].name] = this.abnormal_data[i].number;
      }
      return [data];
    },
    abnormal_data() {
      const abnormal_data = [];
      for (const key in this.data.anomalies_indicateurs_dict) {
        abnormal_data.push({
          name: key,
          number: this.data.anomalies_indicateurs_dict[key],
        });
      }
      return abnormal_data;
    },
  },
};
</script>

<style scoped lang="scss">
.page_header {
  margin-bottom: 20px;
}

.table_list {
  display: flex;
  margin: 20px 0;

  & > div:first-child {
    width: 40%;
  }

  & > div:last-child {
    width: 60%;
  }

  .prompt {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.title {
  border-left: 5px solid #983cc9;
  margin: 20px 0;
  padding-left: 20px;
}

.link {
  color: #266fff;
  cursor: pointer;
}
</style>
